<app-menu-options [nextPossibleSteps]="nextPossibleSteps" (onActionSelected)="onAction($event)">